import { SET_NOTIFICATIONS_DATA, SET_UNREAD_NOTIFICATION_COUNT,  SET_PAGE_LIMIT } from '../types/types';

export const setNotifications = (value, totalCount) => {
  return {
    type: SET_NOTIFICATIONS_DATA,
    payload: { data: value, totalCount },
  };
};

export const setUnreadNotificationCount = (value) => {
  return {
    type: SET_UNREAD_NOTIFICATION_COUNT,
    payload: { data: value },
  };
};

export const setPageLimit = (page,limit) => {
  return {
    type: SET_PAGE_LIMIT,
    payload: { page , limit },
  };
};

export const setPushNotificationLogs = (logs) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS",
    payload: { data: logs },
  };
};

export const setPushNotificationLogsTotalCount = (totalCount) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS_TOTAL_COUNT",
    payload: { data: totalCount },
  };
};

export const setPushNotificationLogsPageLimit = (page,limit) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS_PAGE_LIMIT",
    payload: { page , limit },
  };
};

export const setPushNotificationLogsByGroupId = (logs) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS_BY_GROUP_ID",
    payload: { data: logs },
  };
};

export const setPushNotificationLogsTotalCountByGroupId = (totalCount) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS_TOTAL_COUNT_BY_GROUP_ID",
    payload: { data: totalCount },
  };
};

export const setPushNotificationLogsPageLimitByGroupId  = (page,limit) => {
  return {
    type: "SET_PUSH_NOTIFICATION_LOGS_PAGE_LIMIT_BY_GROUP_ID",
    payload: { page , limit },
  };
};